const rawBackendUrl = import.meta.env.VITE_BACKEND_URL as string | undefined;

let cachedBackendUrl: string | null = null;
let hasCachedValue = false;
let overrideBackendUrl: string | undefined;

export function setBackendBaseUrl(value: string | undefined) {
  const normalized = value?.trim();
  overrideBackendUrl = normalized ? normalized : undefined;
  cachedBackendUrl = null;
  hasCachedValue = false;
}

export function getBackendBaseUrl(): string | undefined {
  if (overrideBackendUrl) {
    return overrideBackendUrl;
  }

  if (!rawBackendUrl) {
    return undefined;
  }

  if (hasCachedValue) {
    return cachedBackendUrl ?? undefined;
  }

  hasCachedValue = true;
  const fallbackBase = typeof window !== 'undefined' ? window.location.origin : undefined;

  try {
    cachedBackendUrl = fallbackBase
      ? new URL(rawBackendUrl, fallbackBase).toString()
      : new URL(rawBackendUrl).toString();
    return cachedBackendUrl;
  } catch (error) {
    console.error('Invalid backend URL configuration', error);
    cachedBackendUrl = null;
    return undefined;
  }
}

export function resolveBackendPath(path: string, baseOverride?: string): string {
  const candidate = baseOverride?.trim() || getBackendBaseUrl();

  if (candidate) {
    try {
      return new URL(path, candidate).toString();
    } catch (error) {
      console.error('Failed to resolve backend path', error);
    }
  }

  return path;
}
